import { Helmet } from 'react-helmet';
import MainContainer from 'src/components/common/MainContainer';
import AIHSCodeLabeling from 'src/features/AIHSCodeLabeling';
import MainLayout from 'src/layouts';

const AIHSCodeLabelingPage = () => {
  return (
    <MainLayout>
      <Helmet title="AI HS Code Labelling" />
      <MainContainer sx={{ mt: 2 }}>
        <AIHSCodeLabeling />
      </MainContainer>
    </MainLayout>
  );
};

export default AIHSCodeLabelingPage;
